import { render } from "./ConfigurationUpgrade.vue?vue&type=template&id=07de11c7&scoped=true"
import script from "./ConfigurationUpgrade.vue?vue&type=script&lang=js"
export * from "./ConfigurationUpgrade.vue?vue&type=script&lang=js"

import "./ConfigurationUpgrade.vue?vue&type=style&index=0&id=07de11c7&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07de11c7"]])

export default __exports__